/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type THideOfferWebsiteModel = IModel<IHideOfferWebsiteRequest, THideOfferWebsiteResponse>;

export interface IHideOfferWebsiteRequest {
  /** Тип сделки **/
  dealType: EDealType;
  /** ID дома, указанного в объявлении **/
  houseId?: number | null;
  /** Realty ID объявления **/
  offerId: number;
  /** Тип объявления **/
  offerType: EOfferType;
  /** Realty ID пользователя, опубликовавшего объявление **/
  publishedUserId: number;
}

export type THideOfferWebsiteResponse = IHideOfferWebsiteResponse200 | IHideOfferWebsiteResponse400;

export interface IHideOfferWebsiteResponse200 extends IModelResponse<IHideOfferWebsiteResponse> {
  statusCode: 200;
}

export interface IHideOfferWebsiteResponse400 extends IModelResponse<IHideOfferWebsiteResponseError> {
  statusCode: 400;
}

export interface IHideOfferWebsiteResponse {
  /** Статус запроса **/
  status?: string | null;
}

export interface IHideOfferWebsiteResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IHideOfferWebsiteResponse | IHideOfferWebsiteResponseError;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EOfferType {
  /** Коммерческая недвижимость **/
  Commercial = 'commercial',
  /** Квартира **/
  Flat = 'flat',
  /** Новостройки **/
  Newobject = 'newobject',
  /** Загородная недвижимость **/
  Suburban = 'suburban',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IHideOfferWebsiteResponse): TResponse200;
  400(response: IHideOfferWebsiteResponseError): TResponse400;
}
